<template>
  <div class="flex items-center">
    <input
      type="radio"
      :id="id"
      :name="name"
      :required="required"
      :disabled="disabled"
      :value="inputValue"
      v-model="model"
      class="focus:ring-green-500 h-4 w-4 text-green-600 border-gray-300"
    />
    <label :for="id" class="ml-3">
      <span class="block text-sm text-gray-700">{{ label }}</span>
    </label>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  label: String,
  name: String,
  id: String,
  modelValue: [String, Number, Boolean],
  inputValue: [String, Number, Boolean],
  tabindex: Number,
  required: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  error: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue']);

const model = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});
</script>
